import axios from 'axios';
import { URLS } from '@constants/urls';
import api from '@helpers/api';

export const getCenterWiseResults = (() => {
  const cancelToken = axios.CancelToken;
  let source = cancelToken.source();
  let isRequestInProcess = false;

  return async ({
    constituencyId,
    percentage,
    timeSlot,
    search,
    page,
    size,
    election_schedule_id,
  }: {
    constituencyId: number | string;
    percentage: number | string;
    timeSlot: number | string;
    page: number;
    size: number;
    search: number | string;
    election_schedule_id: string | number;
  }): Promise<{ data: any }> => {
    if (isRequestInProcess) {
      source.cancel();
      source = cancelToken.source();
    }

    isRequestInProcess = true;

    return api

      .get(
        URLS.GET_CENTER_WISE_RESULTS({
          constituencyId: constituencyId,
          percentage: percentage,
          timeSlot: timeSlot,
          search: search,
          page: page,
          size: size,
          election_schedule_id: election_schedule_id,
        }),
      )
      .then((response) => {
        return { data: response.data };
      })
      .finally(() => {
        isRequestInProcess = false;
      });
  };
})();
